import { useEffect, useRef } from 'react'
import { useFeedStore } from '../../../../store/feed-store'
import styles from './StepsNavigation.module.css'
import { useOnScreen } from '../../../hooks/useOnScreen'

interface StepsNavigationProps {
  numberOfSteps: number
}

const StepsNavigation = ({ numberOfSteps }: StepsNavigationProps) => {
  // TODO: check if this is the best way to create an array of numbers
  const ref = useRef<HTMLDivElement>(null)
  const isOnScreen = useOnScreen(ref)
  const steps = new Array(numberOfSteps).fill(0).map((_, index) => index + 1)
  const { currentStep, setCurrentStep, setStepperVisible } = useFeedStore(
    (state) => state,
  )

  useEffect(() => {
    setStepperVisible(isOnScreen)

    return () => {
      setCurrentStep(1)
    }
  }, [isOnScreen, setCurrentStep, setStepperVisible])

  return (
    <div ref={ref} className={styles.stepsContainer}>
      {steps.map((step) => {
        const isActiveStep = step === currentStep

        return (
          <div
            key={step}
            className={`${styles.step} ${
              isActiveStep ? styles.activeStep : ''
            } `}
          />
        )
      })}
    </div>
  )
}

export default StepsNavigation
